"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFeatureFlagUpdateDto = instanceOfFeatureFlagUpdateDto;
exports.FeatureFlagUpdateDtoFromJSON = FeatureFlagUpdateDtoFromJSON;
exports.FeatureFlagUpdateDtoFromJSONTyped = FeatureFlagUpdateDtoFromJSONTyped;
exports.FeatureFlagUpdateDtoToJSON = FeatureFlagUpdateDtoToJSON;
exports.FeatureFlagUpdateDtoToJSONTyped = FeatureFlagUpdateDtoToJSONTyped;
/**
 * Check if a given object implements the FeatureFlagUpdateDto interface.
 */
function instanceOfFeatureFlagUpdateDto(value) {
    if (!('key' in value) || value['key'] === undefined)
        return false;
    if (!('isActiveForAll' in value) || value['isActiveForAll'] === undefined)
        return false;
    if (!('activeFacilityIds' in value) || value['activeFacilityIds'] === undefined)
        return false;
    return true;
}
function FeatureFlagUpdateDtoFromJSON(json) {
    return FeatureFlagUpdateDtoFromJSONTyped(json, false);
}
function FeatureFlagUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'key': json['key'],
        'isActiveForAll': json['isActiveForAll'],
        'activeFacilityIds': json['activeFacilityIds'],
    };
}
function FeatureFlagUpdateDtoToJSON(json) {
    return FeatureFlagUpdateDtoToJSONTyped(json, false);
}
function FeatureFlagUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'key': value['key'],
        'isActiveForAll': value['isActiveForAll'],
        'activeFacilityIds': value['activeFacilityIds'],
    };
}
//# sourceMappingURL=FeatureFlagUpdateDto.js.map